export const generateCacheKey = (
  item,
  twinId = "",
  planningState = "",
  planId = ""
) => {
  if (!item) return null;
  return `${item.tenant_id}_${item.patient_id}_${item._id}_${item.file_name}_${twinId}_${planningState}_${planId}`;
};

export const generateStateKey = (state = "", twinId = "") => {
  if (!state) return null;
  return `${state}_${twinId}`;
};
